var MeshHelper = (function () {
    function MeshHelper() {
    }
    MeshHelper.invertFaces = function (target) {
        console.log("invert Faces is only a stub");
    };
    return MeshHelper;
}());
export { MeshHelper };
